import SettingsServerModal from './SettingsServerModal';

export default SettingsServerModal;
